module.exports = __webpack_public_path__ + "static/img/wuxian.45f48cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/wuxian.png
// module id = tK/P
// module chunks = 1